<script setup>
const { features } = useFeatures()
const { r } = useRoutes()

function redirectToLegacySchedule() {
  window.location.href = r({ path: '/', isV2Path: false })
}

if (!features.customer_v2_schedule || (features.customer_v2_calendar_allow_user_toggle && !features.customer_v2_calendar_user_toggle))
  redirectToLegacySchedule()

watch(
  () => features.customer_v2_calendar_user_toggle,
  (enabled) => {
    if (!enabled)
      redirectToLegacySchedule()
  },
)
</script>

<template>
  <SchedulePage />
</template>

<route lang="yaml">
meta:
  page_view: true
  fluid: true
  page_classes: lg:max-w-[calc(100%-270px)]
  sticky_container_classes: lg:!left-270px
</route>
